import { Reservation } from '@/root/shared-types'

type CartLine = {
  priceCategory: string
  priceCategoryTranslation: string
  pricePerUnit: number
  totalPrice: number
  totalQuantity: number
}

/**
 * Cart lines of a reservation, one per price category (both legs of a round trip summed), with the reservation total.
 * Every item counts, as the purchase cart always did.
 */
export const getCartSummary = (reservation?: Reservation) => {
  const linesByCategory = (reservation?.items ?? []).reduce<Record<string, CartLine>>((lines, item) => {
    const line = (lines[item.priceCategory] ??= {
      priceCategory: item.priceCategory,
      priceCategoryTranslation: item.priceCategoryTranslation,
      pricePerUnit: item.pricePerUnit,
      totalQuantity: 0,
      totalPrice: 0,
    })
    line.totalQuantity += item.quantity
    line.totalPrice += item.price
    return lines
  }, {})
  const items = Object.values(linesByCategory)

  return {
    items,
    totalPrice: reservation?.paymentInfo?.totalPrice?.amount ?? 0,
    isEmpty: items.length === 0,
  }
}
